import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {BankruptcySettingModel} from '../Models/criminal-model';
import {environment} from '../../../environments/environment';
import {tap} from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class DecisionGridBankruptcyService {

  public bankruptcySettings: BankruptcySettingModel[] = [];
  public bankruptcySettingsSubscription$ = new BehaviorSubject<BankruptcySettingModel[]>([]);

  constructor(private http: HttpClient, private toast: ToastrService) {
  }

  public getBankruptcySettings(clientId: number): Observable<BankruptcySettingModel[]> {
    return this.http.get<BankruptcySettingModel[]>(`${environment.baseURl}/api/decisionGrid/BankruptcySetting/GetBankruptcySettings/${clientId}`)
      .pipe(tap((r: BankruptcySettingModel[]) => {
        this.bankruptcySettings = r;
        this.bankruptcySettingsSubscription$.next(r);
      },
      err => {
        this.toast.error('Error fetching bankruptcy settings!', '', { closeButton: true, disableTimeOut: true })
      }));
  }

  public insertBankruptcySetting(clientId: number, data: BankruptcySettingModel): Observable<any> {

    return this.http.post<BankruptcySettingModel>(`${environment.baseURl}/api/decisionGrid/BankruptcySetting/InsertBankruptcySetting/${clientId}`, data)
      .pipe(tap((r: BankruptcySettingModel) => {
        // Add the new model to the cache
        this.bankruptcySettings.push(r);
      },
      err => {
        this.toast.error('Error saving bankruptcy setting!', '', { closeButton: true, disableTimeOut: true })
      }));

  }

  public updateBankruptcySetting(clientId: number, data: BankruptcySettingModel): Observable<any> {

    const settingId = data.settingId;

    return this.http.post<BankruptcySettingModel>(`${environment.baseURl}/api/decisionGrid/BankruptcySetting/UpdateBankruptcySetting/${clientId}/${settingId}`, data)
      .pipe(tap((r: BankruptcySettingModel) => {
        // this.getBankruptcySettings(clientId).subscribe()
        // Now update the existing model.

      },
      err => {
        this.toast.error('Error updating bankruptcy setting!', '', { closeButton: true, disableTimeOut: true })
      }));
  }

  public deleteBankruptcySetting(clientId: number, settingId: number): Observable<any> {
    return this.http.delete<any>(`${environment.baseURl}/api/decisionGrid/BankruptcySetting/DeleteBankruptcySetting/${clientId}/${settingId}`)
      .pipe(tap(() => {
        // Remove this from the original load
        const idx = this.bankruptcySettings.findIndex(g => {
          return g.settingId === settingId;
        });

        if (idx >= 0) {
          this.bankruptcySettings.splice(idx, 1);
        }

      },
      err => {
        this.toast.error('Error deleting bankruptcy setting!', '', { closeButton: true, disableTimeOut: true })
      }));
  }
}

